import styled from 'styled-components';
import { HtmlTable } from '../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';

export const LivingBalanceSheetTable = styled(HtmlTable)(({ theme }) => ({
  borderBottom: 'none',
  table: {
    thead: {
      tr: {
        th: {
          background: `${theme.colors.neutral[100]}`,
          borderBottom: `1px solid ${theme.colors.neutral[700]}`,
          textTransform: 'uppercase',
          color: theme.colors.neutral['700'],
          fontSize: theme.fontSizes.small,
          fontWeight: 600,
        },

        '@media print': {
          'th, th:first-child': {
            borderTop: 'none',
            borderRight: 'none',
            borderBottom: 'none',
            borderLeft: 'none',
          },
        },
      },
    },
    tbody: {
      'tr:last-child': {
        borderBottom: 'none',
      },
      'tr.hasBottomBorder': {
        boxShadow: `1px 1px 0 ${theme.colors.neutral[800]}`,
      },

      'tr.hasTopBorder': {
        boxShadow: `1px -1px 0 ${theme.colors.neutral[800]}`,
      },

      '@media print': {
        tr: {
          'td, td:first-child': {
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
            // borderBottom: 'none',
          },
        },

        'tr:last-child': {
          td: {
            borderBottom: 'none',
          },
        },
      },
    },
  },
}));
